import React, { useEffect, useRef } from 'react';
import styles from './index.module.scss';

const AnimatedBackground: React.FC = () => {
  const floatingElementsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const createFloatingElements = () => {
      const container = floatingElementsRef.current;
      if (!container) return;

      for (let i = 0; i < 50; i++) {
        const element = document.createElement('div');
        element.className = styles.floatingElement;
        element.style.left = Math.random() * 100 + '%';
        element.style.animationDelay = Math.random() * 20 + 's';
        element.style.animationDuration = (Math.random() * 10 + 15) + 's';
        container.appendChild(element);
      }
    };

    createFloatingElements();

    // Cleanup function
    return () => {
      if (floatingElementsRef.current) {
        floatingElementsRef.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <>
      <div className={styles.overallBackground}> {/* New parent container */}
        <div className={styles.backgroundAnimation} />
        <div className={styles.floatingElements} ref={floatingElementsRef} />
      </div>
    </>
  );
};

export default AnimatedBackground;